import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, Button, Alert, Form, Image } from "react-bootstrap";
import { useAuth } from "contexts/AuthContext";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { auth, db } from "../firebase/config";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import VisitorRecord from "./VisitorRecord";

import { randomString } from "utils/random";
import { imageToThumb } from "utils/image";

const Admin = (props) => {
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [adminRecord, setAdminRecord] = useState();
  const { currentUser, logout } = useAuth();
  const [fetching, setFetching] = useState(false);
  const [visitorList, setVisitorList] = useState([]);
  const [dutyDate, setDutyDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [fetchDate, setFetchDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const refDate = useRef();

  const [image, setImage] = useState();

  const history = useHistory();

  const submitOnDuty = useMemo(
    () => async (dutyDate) => {
      setError("");
      setMessage("");
      console.log(dutyDate, adminRecord);
      if (adminRecord && dutyDate !== adminRecord.dutyDate) {
        try {
          await updateDoc(doc(db, "admins", adminRecord._id), {
            dutyDate: dutyDate,
          });
          setAdminRecord((adminRecord) => ({
            ...adminRecord,
            dutyDate: dutyDate,
          }));
          setMessage("Updated");
          setTimeout(() => {
            setMessage("");
          }, 2000);
        } catch {
          setError("Duty failed");
          setTimeout(() => {
            setError("");
          }, 2000);
        }
      } else {
        // setError("Hmm... you seem to not be there");
      }
    },
    [adminRecord]
  );

  const handleLogout = async () => {
    setError("");
    try {
      await logout();
      history.push("/login");
    } catch {
      setError("Failed to log out");
    }
  };

  const handleConfirm = useMemo(
    () => async (visitor) => {
      if (currentUser) {
        visitor.state = "confirmed";
        visitor.admin = currentUser.email;
        setError("");
        setMessage("");
        try {
          await updateDoc(doc(db, "checkin", visitor._id), {
            state: "confirmed",
            admin: currentUser?.email,
          });
          setMessage(`${visitor.name} has been confirmed`);
          setTimeout(() => {
            setMessage("");
          }, 2000);
        } catch {
          setError("Check-in failed");
          setTimeout(() => {
            setError("");
          }, 2000);
        }
      }
    },
    [currentUser]
  );

  useEffect(() => {
    setImage(adminRecord?.image);
  }, [adminRecord]);

  useEffect(() => {
    const q = query(
      collection(db, "admins"),
      where("email", "==", currentUser.email)
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      if (querySnapshot.empty) {
        setError("No matching admin records");
        setTimeout(() => {
          setError("");
        }, 2000);
        setAdminRecord(undefined);
        return;
      }

      const admins = [];
      querySnapshot.forEach((doc) => {
        admins.push({ ...doc.data(), _id: doc.id });
      });
      console.log("admins: ", currentUser, admins);
      setAdminRecord(admins[0]);
    });
    return () => unsubscribe;
  }, [currentUser]);

  useEffect(() => {
    const q = query(collection(db, "checkin"), where("date", "==", fetchDate));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const visitors = [];
      querySnapshot.forEach((doc) => {
        visitors.push({ ...doc.data(), _id: doc.id });
      });
      console.log("visitors: ", fetchDate, visitors);
      setVisitorList(visitors);
    });
    return () => unsubscribe;
  }, [fetchDate]);

  const handleFetchVisitorList = async () => {
    setFetching(true);
    setTimeout(() => {
      setFetching(false);
    }, 3000);
  };

  let content = (
    <>
      <Card className="mt-3">
        <Card.Body>
          <h2 className="text-center mb-4">Admin State</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="info">{message}</Alert>}
          <strong>Logged in as: </strong>
          {currentUser.email}
          <Link to="/update-profile" className="btn btn-primary w-100 mt-3">
            Update Profile
          </Link>
          <Button
            className="w-100 mt-4"
            onClick={() =>
              submitOnDuty(dutyDate !== adminRecord?.dutyDate ? dutyDate : "")
            }
          >
            {dutyDate !== adminRecord?.dutyDate
              ? "Open For Business"
              : "Take A Break"}
          </Button>
        </Card.Body>
      </Card>
      <Card className="mt-3">
        <Card.Body>
          <h2 className="text-center mb-4">Visitor List</h2>
          <Form.Control
            className="mt-3"
            type="date"
            name="query_date"
            error={"Date picker error"}
            value={fetchDate}
            ref={refDate}
            onChange={(e) => setFetchDate(e.target.value)}
          />
          {visitorList.map((v) => (
            <VisitorRecord
              visitor={v}
              key={v._id}
              confirm={handleConfirm}
            ></VisitorRecord>
          ))}
        </Card.Body>
      </Card>

      <div className="w-100 text-center mt-2">
        <Button variant="link" onClick={handleLogout}>
          Log out
        </Button>
      </div>
    </>
  );
  return content;
};

export default Admin;
